import React, { useRef, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, IconButton, MenuItem, Stack } from '@mui/material';
import MenuPopover from '../../../shared/components/menuPopover';
import SAflag from '../../../../../../assets/images/saudi-arabia.png';
import globalFlag from '../../../../../../assets/images/global.png';
import { RegionService } from '../../../../../../services/regionService';
import { RegionTypes } from '../../../../../../constants/regionType';
import { buildSiblingRegionUrl } from '../../../../../../helpers/buildSiblingRegionUrlHelper';

const REGIONS = [
	{ name: 'Global', code: RegionTypes.Global, icon: globalFlag },
	{ name: 'Saudi Arabia', code: RegionTypes.SaudiArabia, icon: SAflag },
];

export default function RegionSelector() {
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);

	const regionService = new RegionService();
	const currentRegion = regionService.currentRegion();
	const siblingUrl = buildSiblingRegionUrl(
		currentRegion,
		process.env.REACT_APP_ADMIN_URL,
		process.env.REACT_APP_ADMIN_URL_SA,
		window.location.pathname,
		window.location.search,
		window.location.hash
	);

	if (!siblingUrl) {
		return null;
	}

	const current = REGIONS.find((region) => region.code === currentRegion);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<>
			<IconButton
				ref={anchorRef}
				onClick={handleOpen}
				aria-label="Change region"
				className="!text-white hover:!bg-white/20"
				color={open ? 'primary' : 'default'}
				sx={{ height: 35, px: 1, borderRadius: '8px' }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
					<img
						width={'20px'}
						height={'20px'}
						style={{ borderRadius: '50%', objectFit: 'cover' }}
						src={current.icon}
						alt={current.name}
					/>
					<Box
						component="span"
						sx={{ fontSize: 13, fontWeight: 600, lineHeight: 1 }}>
						{current.code.toUpperCase()}
					</Box>
					<KeyboardArrowDownIcon
						sx={{
							fontSize: 18,
							transition: 'transform .2s',
							transform: open ? 'rotate(180deg)' : 'none',
						}}
					/>
				</Box>
			</IconButton>

			<MenuPopover
				open={open}
				onClose={handleClose}
				anchorEl={anchorRef.current}
				sx={{
					mt: 1.5,
					ml: 0.75,
					width: 180,
					'& .MuiMenuItem-root': {
						px: 1,
						typography: 'body2',
						borderRadius: 0.75,
					},
				}}>
				<Stack spacing={0.75}>
					{REGIONS.map((region) => {
						const isCurrent = region.code === currentRegion;
						return (
							<MenuItem
								key={region.code}
								selected={isCurrent}
								disabled={isCurrent}
								{...(isCurrent
									? {}
									: { component: 'a', href: siblingUrl, onClick: handleClose })}>
								<Box
									component="img"
									alt={region.name}
									src={region.icon}
									sx={{ width: 20, mr: 2 }}
								/>
								{region.name}
							</MenuItem>
						);
					})}
				</Stack>
			</MenuPopover>
		</>
	);
}
